import { render } from "./FriendCard-ShowCode.vue?vue&type=template&id=68cb84b4&scoped=true"
import script from "./FriendCard-ShowCode.vue?vue&type=script&lang=js"
export * from "./FriendCard-ShowCode.vue?vue&type=script&lang=js"

import "./FriendCard-ShowCode.vue?vue&type=style&index=0&id=68cb84b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68cb84b4"]])

export default __exports__